import { Component, OnDestroy } from '@angular/core';
import { DateRange, MatCalendar, MatDateRangePicker, } from '@angular/material/datepicker';
import { Subject } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'fury-calendar-header-with-presets',
  templateUrl: 'presets.component.html',
  styleUrls: ['presets.component.scss'],
})
export class MatCalendarHeaderWithPresetsComponent<D> implements OnDestroy {
  presets = [
    {
      label: 'Vandaag',
      range: {
        start: moment(),
        end: moment(),
      },
    },
    {
      label: 'Gisteren',
      range: {
        start: moment().subtract(1, 'days'),
        end: moment().subtract(1, 'days'),
      },
    },
    {
      label: 'Laatste 7 dagen',
      range: {
        start: moment().subtract(7, 'days'),
        end: moment(),
      },
    },
    {
      label: 'Laatste 30 dagen',
      range: {
        start: moment().subtract(30, 'days'),
        end: moment(),
      },
    },
    {
      label: 'Laatste 90 dagen',
      range: {
        start: moment().subtract(90, 'days'),
        end: moment(),
      },
    },
    {
      label: 'Laatste 12 maanden',
      range: {
        start: moment().subtract(1, 'years'),
        end: moment(),
      },
    },
    {
      label: 'Vorig jaar',
      range: {
        start: moment().subtract(1, 'years').startOf('years'),
        end: moment().subtract(1, 'years').endOf('years'),
      },
    },
    {
      label: 'Dit jaar',
      range: {
        start: moment().startOf('years'),
        end: moment(),
      },
    },
  ];
  private _destroyed: Subject<void> = new Subject<void>();

  constructor(
    private calendar: MatCalendar<D>,
    private datePicker: MatDateRangePicker<D>,
  ) {
  }

  selectPreset(presetDateRange: { start: D; end: D }): void {
    if (presetDateRange.end && this.calendar) {
      this.calendar.selected = new DateRange<D>(
        presetDateRange.start,
        presetDateRange.end
      );

      this.datePicker.select(presetDateRange.start);
      this.datePicker.select(presetDateRange.end);

      this.calendar._goToDateInView(presetDateRange.end, 'month');
      this.datePicker.close();
    }
  }

  ngOnDestroy(): void {
    this._destroyed.next();
    this._destroyed.complete();
  }
}
